import { tableStyles } from './uiStyles';
import { getEventsData, isValidationDashboard, removeLoader } from './utils';
import { onCreatePanel } from './validationPanelUI';
import { summaryStyles, summaryUI } from './validationSummaryUI';
import { validator } from './validator';
import { domToImg } from './loadExternalLibs';
/*
{
  [id]: {
    gv: {},
    ga: {},
    gv_timestamp:number,
    ga_timestamp:number,
    tableStatus:"single"|"done"|undefined,
  },
}
*/
const eventsMap = new Map();
let lastGVIndex = 0;
let lastGAIndex = 0;
let isDash = isValidationDashboard();
let isHAR = window.HAR_MODE;

const makeEvents = () => {
  const { gvData, gaData } = getEventsData(isDash);

  const gvURL = 'gv';
  const gaURL = 'ga';

  if (gvData && gvData.length && gvData.length !== lastGVIndex) {
    for (let i = lastGVIndex; i < gvData.length; i++, lastGVIndex++) {
      let eventData = gvData[i];
      let eventId = eventData.urlBody.panel_event_id;
      if (!eventId) continue;
      let eventPresent = eventsMap[eventId];
      if (eventPresent && eventPresent.gv) continue;
      eventValidation(gvURL, eventData.urlBody);
    }
  }
  if (gaData && gaData.length && gaData.length !== lastGAIndex) {
    for (let i = lastGAIndex; i < gaData.length; i++, lastGAIndex++) {
      let eventData = gaData[i];
      let eventId = eventData.urlBody.panel_event_id;
      if (!eventId) continue;
      let eventPresent = eventsMap[eventId];
      if (eventPresent && eventPresent.ga) continue;
      eventValidation(gaURL, eventData.urlBody);
    }
  }
  validator(eventsMap);
};

export const validationDashboadInterceptor = () => {
  setInterval(makeEvents, 5 * 1000);
};

export const loadValidationPannel = () => {
  summaryStyles();
  tableStyles();
  removeLoader();
  if (!isDash) {
    onCreatePanel();
  }
  summaryUI();

  if (isHAR) {
    window.harCompareEvents = makeEvents;
  } else {
    //live
    makeEvents();
    validationDashboadInterceptor();
  }
  domToImg();
};

const eventValidation = (url, body) => {
  const isMP = url === 'ga';
  const isGV = url === 'gv';

  if (!isMP && !isGV) return;

  const event = typeof body === 'object' ? body : JSON.parse(body);
  //batched
  if (Array.isArray(event)) {
    event.forEach((each) => {
      updateEventMap(each, isGV);
    });
  } else {
    updateEventMap(event, isGV);
  }
  return event;
};
const updateEventMap = (event, isGV) => {
  let eventObj = { ...event };

  const { panel_event_id: id } = eventObj;

  delete eventObj.panel_event_id;
  let key = isGV ? 'gv' : 'ga';
  let timeStampKey = `${key}_timestamp`;
  eventsMap.set(id, {
    ...eventsMap.get(id),
    [key]: eventObj,
    [timeStampKey]: Date.now(),
  });
};
